import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_PRODUCTINVENTORYBRANCH,
  DELETE_PRODUCTINVENTORYBRANCH,
  UPDATE_PRODUCTINVENTORYBRANCH,
  ADD_NEW_PRODUCTINVENTORYBRANCH,
} from "./actionType";

import {
  getProductInventoryBranchSuccess,
  getProductInventoryBranchFail,
  deleteProductInventoryBranchSuccess,
  deleteProductInventoryBranchFail,
  updateProductInventoryBranchSuccess,
  updateProductInventoryBranchFail,
  addProductInventoryBranchSuccess,
  addProductInventoryBranchFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveProductInventoryBranchApi,
  getProductInventoryBranchApi,
  updateProductInventoryBranchApi,
  deleteProductInventoryBranchApi,
  addNewProductInventoryBranchApi
} from "../../helpers/backend_helper";

function* getProductInventoryBranch({ payload: productInventoryBranch }) {
  try {
    const response = yield call(getProductInventoryBranchApi, productInventoryBranch);
    yield put(getProductInventoryBranchSuccess(GET_PRODUCTINVENTORYBRANCH, response.data));
  } catch (error) {
    yield put(getProductInventoryBranchFail(GET_PRODUCTINVENTORYBRANCH, error));
  }
}

function* onUpdateProductInventoryBranch({ payload: productInventoryBranch }) {
  try {
    if (productInventoryBranch.setApprove) {
      const response = yield call(approveProductInventoryBranchApi, productInventoryBranch);
      yield put(updateProductInventoryBranchSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateProductInventoryBranchApi, productInventoryBranch);
      yield put(updateProductInventoryBranchSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateProductInventoryBranchFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteProductInventoryBranch({ payload: productInventoryBranch }) {
  try {
    const response = yield call(deleteProductInventoryBranchApi, productInventoryBranch);
    yield put(deleteProductInventoryBranchSuccess({ productInventoryBranch, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteProductInventoryBranchFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewProductInventoryBranch({ payload: productInventoryBranch }) {
  try {
    const response = yield call(addNewProductInventoryBranchApi, productInventoryBranch);
    yield put(addProductInventoryBranchSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addProductInventoryBranchFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetProductInventoryBranch() {
  yield takeEvery(GET_PRODUCTINVENTORYBRANCH, getProductInventoryBranch);
}

export function* watchUpdateProductInventoryBranch() {
  yield takeEvery(UPDATE_PRODUCTINVENTORYBRANCH, onUpdateProductInventoryBranch);
}

export function* watchDeleteProductInventoryBranch() {
  yield takeEvery(DELETE_PRODUCTINVENTORYBRANCH, onDeleteProductInventoryBranch);
}

export function* watchAddNewProductInventoryBranch() {
  yield takeEvery(ADD_NEW_PRODUCTINVENTORYBRANCH, onAddNewProductInventoryBranch);
}

function* productInventoryBranchSaga() {
  yield all([
    fork(watchGetProductInventoryBranch),
    fork(watchDeleteProductInventoryBranch),
    fork(watchUpdateProductInventoryBranch),
    fork(watchAddNewProductInventoryBranch)
  ]);
}

export default productInventoryBranchSaga;
